import React, { Fragment, useState } from 'react';
import "./Styles/SurveyForm.css";
import { Input, FormControl, InputLabel, FormHelperText, Fab, RadioGroup,
    Radio, FormControlLabel, FormLabel, TextField } from '@material-ui/core';
import SendIcon from "@material-ui/icons/Send";


export const SurveyForm = ({questions, handlerChange, submitAnswers}) => {
    const [errors, setErrors] = useState({});
    const renderQuestion = (question) => {
        if(question) {
            switch (question.question_type) {
                case "Small Answer":
                    return (<FormControl style={{width: "100%", marginBottom: "5px"}}
                                error={errors[question.id] ? true : false} required onChange={(e) => handlerAnswer(e.target, question)}>
                                <FormLabel style={{}}>{question.question}</FormLabel>
                                <Input style={{marginTop: "0px"}} id={question.id} type="text" rowsMax={1} value={question.answer.answer}/>
                                <FormHelperText id="component-error-text" style={{marginBottom: "3px"}}>{errors[question.id] && errors[question.id]}</FormHelperText>
                            </FormControl>);
                case "Multiple selection":
                    return (<FormControl style={{width: "100%", marginBottom: "5px"}}
                                error={errors[question.id] ? true : false} 
                                >
                                <FormLabel component="legend">{question.question}</FormLabel>
                                <RadioGroup onChange={(e) => handlerAnswer(e.target, question)}>
                                    {
                                        question.posible_answer.length > 0  && question.posible_answer.map((pa, i) => (
                                            <FormControlLabel
                                                key={i}
                                                value={pa}
                                                control={<Radio id={question.id} color="primary"/>}
                                                label={pa}
                                                labelPlacement="end"
                                            />
                                        ))
                                    }
                                </RadioGroup>
                                <FormHelperText id="component-error-text" style={{marginBottom: "3px"}}>{errors[question.id] && errors[question.id]}</FormHelperText>
                            </FormControl>);
                case "Paragraph":
                    return (<FormControl style={{width: "100%", marginBottom: "5px"}}
                                error={errors[question.id] ? true : false}
                                onChange={(e) => handlerAnswer(e.target, question)}>
                                <FormLabel>{question.question}</FormLabel>
                                <TextField
                                    style={{marginTop: "0px"}}
                                    error={errors[question.id] ? true : false}
                                    id={question.id}
                                    required
                                    multiline
                                    rowsMax="4"
                                    value={question.answer.answer} 
                                    margin="normal"
                                />
                                <FormHelperText id="component-error-text" style={{marginBottom: "3px"}}>{errors[question.id] && errors[question.id]}</FormHelperText>
                            </FormControl>);
                case "Number":
                    return (<FormControl style={{width: "100%", marginBottom: "5px"}}
                                error={errors[question.id] ? true : false} required onChange={(e) => handlerAnswer(e.target, question)}>
                                <FormLabel>{question.question}</FormLabel>
                                <Input  id={question.id} type="number" value={question.answer.answer}/>
                                <FormHelperText id="component-error-text" style={{marginBottom: "3px"}}>{errors[question.id] && errors[question.id]}</FormHelperText>
                            </FormControl>);
                case "Date":
                    return (<FormControl style={{width: "100%", marginBottom: "5px"}}
                                error={errors[question.id] ? true : false} required onChange={(e) => handlerAnswer(e.target, question)}>
                                <FormLabel>{question.question}</FormLabel>
                                <Input id={question.id} type="date" value={question.answer.answer} />
                                <FormHelperText id="component-error-text" style={{marginBottom: "3px"}}>{errors[question.id] && errors[question.id]}</FormHelperText>
                            </FormControl>);
            }
        }
    }
    
    const handlerAnswer = (target, question) => {
        const {value, id, type, required} = target;
        if(required && (!value || value.length === 0)) {
            setErrors({
                ...errors,
                [id]: "Completa este campo"
            });
        } else {
            setErrors({
                ...errors,
                [id]: ""
            });
        }
        handlerChange(question, value);
    }

    const actionSumbit = (e) => {
        e.preventDefault();
        let values = Object.keys(errors);
        if(values.length === 0 || values.length < questions.length) {
            let questionErrors = {};
            for (const q of questions) {
                let key = values.find(id => q.id === Number(id));
                if(key)  {
                    questionErrors = {...questionErrors, [key]: errors[key]};
                }else {
                    questionErrors = {...questionErrors, [q.id]: "Completa este campo"};
                }
            }
            setErrors({
               ...questionErrors
            });
            return;
        }
        if(Object.values(errors).filter(v => v).length === 0) {
            submitAnswers();
        }
    }

    return(
       <div className="SurveyFormCard card">
          <div className="card-body">
              <form onSubmit={(e) => actionSumbit(e)} noValidate>
                  <div className="form-group">
                    {
                        questions.length > 0 && questions.map((question) => 
                            <Fragment key={question.id}>
                                {renderQuestion(question)}
                            </Fragment>
                        )
                    }
                  </div>
                  <Fab type="sumbit" variant="extended" style={{width: "100%", backgroundColor: "#dc3545", color: "#eee"}}>
                    <SendIcon />
                        Enviar
                    </Fab>
              </form>
          </div>
       </div> 
    )
}